export const DEMO_RESERVATION_LOCATION_ID = '875'

const DEMO_RESERVATION_EMAIL_PREFIX = 'demo'
const DEMO_RESERVATION_EMAIL_DOMAIN = 'test.com'
const DEMO_RESERVATION_RANDOM_PART_LENGTH = 12
const DEMO_RESERVATION_PHONE_PREFIX = '+316'
const DEMO_RESERVATION_PHONE_RANDOM_PART_LENGTH = 8

export const isDemoReservationLocation = (locationId) => (
    String(locationId || '') === DEMO_RESERVATION_LOCATION_ID
)

export const generateDemoReservationEmail = () => {
    const timestampPart = Date.now().toString(36)
    const randomPart = Math.random().toString(36).slice(2)
    const combinedPart = `${timestampPart}${randomPart}`
        .slice(0, DEMO_RESERVATION_RANDOM_PART_LENGTH)
        .padEnd(DEMO_RESERVATION_RANDOM_PART_LENGTH, '0')
    return `${DEMO_RESERVATION_EMAIL_PREFIX}${combinedPart}@${DEMO_RESERVATION_EMAIL_DOMAIN}`
}

const generateRandomDigits = (length) => {
    return Array.from({length}, () => Math.floor(Math.random() * 10)).join('')
}

export const generateDemoReservationPhone = () => {
    const randomPart = generateRandomDigits(DEMO_RESERVATION_PHONE_RANDOM_PART_LENGTH)
    return `${DEMO_RESERVATION_PHONE_PREFIX}${randomPart}`
}
